import { render, staticRenderFns } from "./CustomersListItem.vue?vue&type=template&id=61ffe69c&scoped=true&"
import script from "./CustomersListItem.vue?vue&type=script&lang=js&"
export * from "./CustomersListItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomersListItem.vue?vue&type=style&index=0&id=61ffe69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ffe69c",
  null
  
)

export default component.exports